import { atomWithStorage } from 'jotai/utils'
import type { ProductType } from 'types/assembly/model'

export const selectedProductAtom = atomWithStorage<ProductType | undefined>(
  'selectedProductAtom',
  undefined
)

export const productQuantitiesAtom = atomWithStorage<number[]>(
  'productQuantitiesAtom',
  []
)

export const orderContainersAtom = atomWithStorage<string[]>(
  'orderContainersAtom',
  []
)

export const selectedContainersAtom = atomWithStorage<string[]>(
  'selectedContainersAtom',
  []
)

export const palletProductsAtom = atomWithStorage<ProductType[]>(
  'palletProductsAtom',
  []
)

export const containerLocationAtom = atomWithStorage<{
  container: string
  location: string
}>('containerLocationAtom', {
  container: '',
  location: ''
})
